import { render, staticRenderFns } from "./SubscriptionPeriod.vue?vue&type=template&id=522e08ac&"
import script from "./SubscriptionPeriod.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPeriod.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPeriod.vue?vue&type=style&index=0&id=522e08ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports